module.exports = __webpack_public_path__ + "img/26-ram-alt.83f43844.png";